module.exports = __webpack_public_path__ + "media/images/logo-ecf6d87ead9f9e6928128d38e00f496d.svg";